import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from "moment";
import React, { useEffect, useState } from "react";
export default function Grstatus(param) {
    var statusID = param.statusID, statusName = param.statusName, finanStatusID = param.finanStatusID;
    var _useState = _sliced_to_array(useState({
        color: "#3FA5FF",
        bg: "#E5FAFF",
        statusName: "",
        isFinanVerify: false,
        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
    }), 2), statusObj = _useState[0], setStatusObj = _useState[1];
    useEffect(function() {
        switch(statusID){
            case 1:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#747474",
                        bg: "#F4F4F4",
                        statusName: statusName,
                        isFinanVerify: finanStatusID,
                        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
                        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
                    });
                });
                break;
            case 4:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#26C6F9",
                        bg: "#E5F8FE",
                        statusName: statusName,
                        isFinanVerify: finanStatusID,
                        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
                        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
                    });
                });
                break;
            case 5:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#FF731D",
                        bg: "rgba(255, 115, 29, 0.15)",
                        statusName: statusName,
                        isFinanVerify: finanStatusID,
                        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
                        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
                    });
                });
                break;
            case 6:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(114, 225, 40, 0.87)",
                        bg: "rgba(238, 251, 229, 1)",
                        statusName: statusName,
                        isFinanVerify: finanStatusID,
                        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
                        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
                    });
                });
                break;
            case 7:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(249, 80, 87, 1)",
                        bg: "rgba(255, 0, 0, 0.15)",
                        statusName: statusName,
                        isFinanVerify: finanStatusID,
                        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
                        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
                    });
                });
                break;
            default:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#26C6F9",
                        bg: "#E5F8FE",
                        statusName: statusName,
                        isFinanVerify: finanStatusID,
                        finanText: finanStatusID === 5 ? "รอแก้ไข" : "ตรวจสอบแล้ว",
                        finanColor: finanStatusID === 5 ? "#FF0000" : "#565DFF"
                    });
                });
                break;
        }
    }, [
        statusID,
        finanStatusID
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            statusObj.isFinanVerify && /*#__PURE__*/ _jsx("div", {
                className: "text-center",
                style: {
                    color: statusObj.finanColor
                },
                children: statusObj.finanText
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-1 mx-auto text-center",
                style: {
                    color: statusObj.color,
                    backgroundColor: statusObj.bg,
                    borderRadius: "20px"
                },
                children: statusObj.statusName
            })
        ]
    });
}
